import { Directive, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NgControl } from '@angular/forms';

/**
 * This directive helps disable/enable form controls based on a condition, and prevents the warning message in console that says:
 *
 * "It looks like you’re using the disabled attribute with a reactive form directive. If you set disabled to true when you set up
 * this control in your component class, the disabled attribute will actually be set in the DOM for you. We recommend using this
 * approach to avoid ‘changed after checked’ errors."
 *
 * source: https://netbasal.com/disabling-form-controls-when-working-with-reactive-forms-in-angular-549dd7b42110
 */
@Directive({
  selector: '[disableControl]'
})
export class DisableControlDirective implements OnChanges {
  @Input() disableControl: boolean;

  constructor(private ngControl: NgControl) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.disableControl) {
      const action = this.disableControl ? 'disable' : 'enable';
      this.ngControl.control[action]();
    }
  }
}
